
<template>
    <div>

        <div class="container">
            <div class="row">

                <div class="col-lg-12">
                    <h3 class="mb-0 text-uppercase">Uploaded Documents</h3>
                    <hr class="my-4" />
                </div>

                <div class="col-lg-12" v-if="documents && documents.length > 0">
                    <div class="row">
                        <div
                            class="col-sm-4 text-center borderLine"
                            v-for="(document, index) in documents"
                            :key="index"
                        >
                            <br>
                            <h4 class="text-capitalize height-50">
                                {{ document.description ? document.description : 'No Document Uploaded' }}
                            </h4><br>
                            <base-button
                                type="primary"
                                size="sm"
                                v-if="document.hasFile"
                                @click="viewDocument(document.fileNameExt, index)"
                            >
                                <i class="fa fa-eye"></i>
                                {{ isLoading && (isIndex == index) ? 'Please Wait...' : 'View File'}}
                            </base-button>

                            <badge size="sm"
                                type="danger"
                                v-if="! document.hasFile"
                            >
                                No Document Uploaded
                            </badge>
                        </div>
                    </div>
                </div>

                <div
                    v-if="documents && documents.length == 0"
                    class="col-sm-12 text-center"
                >
                    <base-alert type="warning">
                        <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                        <span class="alert-inner--text">
                            No documents added yet!!!
                        </span>
                    </base-alert>
                </div>

                <div class="col-lg-12">
                    <hr class="my-4" />
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import moment from 'moment';
    import { mapActions } from 'vuex'; 

    export default {
        name: 'Documents',
        props: ['documents', 'userId'],
        filters: {
            formatDate(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            }
        },
        data() {
            return {
                isLoading: false,
                isIndex: null
            }
        },
        methods: {
            ...mapActions(['viewUserDocument']),
            getStatus(status) {
                return (status == 'yes') ? 'Current' : 'Past';
            },
            async viewDocument(filename, index) {// view user document
                this.isLoading = true;
                this.isIndex = index;
                this.viewUserDocument({filename : filename, id: this.userId}).then(() => {
                    this.isLoading = false; // document will be opened in new tab      
                    this.isIndex = null;              
                }).
                catch(err => {
                    swal.fire(err.message+"!", "An error occurred while fetching document, try again...", "warning");
                });
            }
        }
    };
</script>
<style scoped>
    .marginTop40 {
        margin-top: 40px;
    }
</style>
